import type { ComposeModalMode } from '@packages/table-builder';

/** View footer Edit is driven by `meta.actions[0]` — omit button when no action is declared. */
export function shouldShowComposeViewEditAction(
  mode: ComposeModalMode,
  primaryAction: unknown,
): boolean {
  return mode === 'view' && primaryAction != null;
}
